import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { ReviewsTable } from "@/features/reviews/components/reviews-table"
import { reviewQueries } from "@/queries/reviews"

const searchSchema = z.object({
  page: z.coerce.number().int().positive().catch(1),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/reviews/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(reviewQueries.list(deps)),
  component: ReviewsPage,
})

function ReviewsPage() {
  const { page } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Reviews" />
      <ReviewsTable
        page={page}
        onPageChange={(next) => void navigate({ search: { page: next } })}
      />
    </>
  )
}
